import forOwn from 'mout/object/forOwn'

export default function findHighestGroupUA(groupUAs, role) {
  let output
  function findFirst (term) {
    let found = null
    let onlyOnce = false
    forOwn(groupUAs, (val, key, o) => {
      if (val.groupType === term && !onlyOnce) {
        onlyOnce = true
        found = val
      }
    }) 
    return found
  }

  let i = 0

  const searchTermsByRole = {
    'District Admin': ['School District', 'School', 'Teacher', 'Class'],
    'School Admin': ['School', 'Teacher', 'Class'],
    'Teacher': ['Teacher', 'Class'],
  }

  const searchTerms = searchTermsByRole[role]

  while (!output && i < searchTerms.length) {
    output = findFirst(searchTerms[i])
    i++
  }

  return output

}


// WEBPACK FOOTER //
// ./src/helpers/assessment/findHighestGroupUA.js